import type { ReactNode } from 'react';
import { Eyebrow } from '@/components/ui/Eyebrow';

type PageHeaderProps = {
  eyebrow: string;
  /** ReactNode so callers can pass an `<em>` emphasis segment, e.g. `Services shaped around your <em>space</em>.` */
  title: ReactNode;
  lead?: string;
  /** Forwarded to `Eyebrow` — every page's `PageHeader` is a primary eyebrow,
   * so callers pass `spark` to show the gold gleam accent. */
  spark?: boolean;
};

/** Inner-page header, matching the mockup's `.phead`. */
export const PageHeader = ({ eyebrow, title, lead, spark }: PageHeaderProps) => (
  <div className="pt-[52px] pb-2 md:pt-20">
    <Eyebrow className="mb-[18px]" spark={spark}>
      {eyebrow}
    </Eyebrow>
    <h1 className="t-h1 [&_em]:text-primary-deep [&_em]:italic">{title}</h1>
    {lead ? <p className="text-ink-soft mt-[22px] max-w-[54ch] text-[16.5px]">{lead}</p> : null}
  </div>
);
